import Vue from "vue";
import VueRouter from "vue-router";
import AuthService from "../services/auth-service";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {  
  const authService = new AuthService();
  const user = await authService.getUser();  
  const isLoggedIn = user && !user.expired;
  const authorizedRoles = to.meta.authorizedRoles;  
  const isAuthorized =
    !authorizedRoles || (isLoggedIn && hasAnyRole(user, authorizedRoles));

  if (!isLoggedIn) {    
    await authService.login();
  }

  if (!isAuthorized) {
    next("/unauthorized");
  }
  next();
});

function hasAnyRole(user, roles) {
  return roles.some((r) => hasRole(user, r));
}

function hasRole(user, role) {
  if (!user) {
    return false;
  }
  return user.profile.role.includes(role);
}

export default router;
